import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NotifState {
  pendingMismatchRequests: number;
  setPendingMismatchRequests: (pendingMismatchRequests: number) => void;
  pendingFlexiRequests: number;
  setPendingFlexiRequests: (pendingFlexiRequests: number) => void;
  showNotification: boolean;
  setShowNotification: (showNotification: boolean) => void;
}

const initialState = {
  pendingMismatchRequests: 0,
  pendingFlexiRequests: 0,
  showNotification: false,
};

export const useNotifState = create<NotifState>()(
  persist(
    (set, get) => ({
      ...initialState,
      setPendingMismatchRequests: (pendingMismatchRequests: number) => {
        const curr = get();
        if (pendingMismatchRequests === curr.pendingMismatchRequests) return;

        set({
          pendingMismatchRequests,
          showNotification:
            pendingMismatchRequests > curr.pendingMismatchRequests,
        });
      },
      setPendingFlexiRequests: (pendingFlexiRequests: number) => {
        const curr = get();
        if (pendingFlexiRequests === curr.pendingFlexiRequests) return;

        set({
          pendingFlexiRequests,
          showNotification:
            pendingFlexiRequests > curr.pendingFlexiRequests,
        });
      },
      setShowNotification: (showNotification: boolean) =>
        set({ showNotification }),
    }),
    {
      name: 'notifs-storage',
    }
  )
);
